import { Component, ErrorInfo, ReactElement } from 'react'

type Props = { children: ReactElement | ReactElement[] }
type State = { hasError: boolean }

class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = { hasError: false }
    }

    static getDerivedStateFromError(): any {
        return { hasError: true }
    }

    componentDidCatch(error: Error, info: ErrorInfo): void {
        console.error('Crash:', error, info)
    }

    render(): any {
        if (this.state.hasError) {
            return (
                <div className="flex box-border items-center justify-center w-full h-full">
                    <p>Une erreur est survenue.</p>
                </div>
            )
        }

        return this.props.children
    }
}

export default ErrorBoundary
